import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { CircularProgress, lighten, LinearProgress, makeStyles, withStyles } from '@material-ui/core';
import { brand500Colors } from '../Theme';
var sizes = {
  small: 24,
  medium: 40,
  large: 75
};
var useStyle = makeStyles({
  rotateColors: {
    animation: "$rotateColors 5s infinite"
  },
  '@keyframes rotateColors': {
    '0%': {
      color: brand500Colors[0]
    },
    '25%': {
      color: brand500Colors[1]
    },
    '50%': {
      color: brand500Colors[2]
    },
    '75%': {
      color: brand500Colors[3]
    },
    '100%': {
      color: brand500Colors[0]
    }
  }
});

var makeLinearStyle = function makeLinearStyle() {
  var backgroundColor = brand500Colors[Math.floor(Math.random() * brand500Colors.length)];
  return {
    root: {
      width: '100%',
      backgroundColor: lighten(backgroundColor, 0.5)
    },
    bar: {
      backgroundColor: backgroundColor
    }
  };
};

var Spinner = function Spinner(_ref) {
  var e2e = _ref.e2e,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'circular' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;

  var _useStyle = useStyle(),
      rotateColors = _useStyle.rotateColors;

  var circular = /*#__PURE__*/React.createElement(CircularProgress, _extends({}, e2e && {
    'data-e2e': e2e
  }, {
    size: sizes[size],
    ref: function ref(elem) {
      if (elem) {
        var svg = elem.querySelector('svg');
        var newClass = "".concat(svg.className.baseVal, " ").concat(rotateColors);
        svg.className.baseVal = newClass;
      }
    }
  }));
  var StyledLinearProgress = withStyles(makeLinearStyle())(LinearProgress);
  var linear = /*#__PURE__*/React.createElement(StyledLinearProgress, e2e && {
    'data-e2e': e2e
  });
  return variant === 'linear' ? linear : circular;
};

export default Spinner;

try {
  Spinner.__docgenInfo = {
    description: '',
    displayName: 'Spinner',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      variant: {
        defaultValue: {
          value: 'circular'
        },
        description: '',
        name: 'variant',
        required: false,
        type: {
          name: 'enum',
          raw: '"circular" | "linear"',
          value: [{
            value: '"circular"'
          }, {
            value: '"linear"'
          }]
        }
      },
      size: {
        defaultValue: {
          value: 'medium'
        },
        description: '',
        name: 'size',
        required: false,
        type: {
          name: 'enum',
          raw: '"small" | "large" | "medium"',
          value: [{
            value: '"small"'
          }, {
            value: '"large"'
          }, {
            value: '"medium"'
          }]
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map